export class BusinessException extends Error {
    public code: string;
    public level: number;
    public message: string;

    constructor(code: string);
    constructor(code: string, msg?: string);
    constructor(code: string, level?: number, msg?: string);
    constructor(code: string, levelOrMsg?: string | number, msg?: string) {
        super();

        this.code = code;

        if (msg) {
            this.message = msg;

            if (levelOrMsg && typeof levelOrMsg == "number") {
                this.level = levelOrMsg;
            }
        } else if (typeof levelOrMsg == "string") {
            this.message = levelOrMsg;
        }
    };

}